import React from 'react';
import { DivButton } from '../root/components/DivButton';
import classnames from 'classnames';
import styles from './MobileBenefitsTable.module.scss';

export const MobileBenefitsTable: React.FC<{ tier?: number }> = ({ tier }) => {
  const [selectedTab, setSelectedTab] = React.useState<number>(tier ?? 0);

  return (
    <div>
      <div className={styles.mobileBenefitsTableTabs}>
        <DivButton className={classnames({ [styles.selected]: selectedTab === 0 })} onClick={() => setSelectedTab(0)} label="Hive member benefits">
          <div>Hive Member</div>
        </DivButton>
        <DivButton className={classnames({ [styles.selected]: selectedTab === 1 })} onClick={() => setSelectedTab(1)} label="Honey Bee member benefits">
          Honey Bee*
        </DivButton>
        <DivButton className={classnames({ [styles.selected]: selectedTab === 2 })} onClick={() => setSelectedTab(2)} label="Queen Bee member benefits">
          Queen Bee**
        </DivButton>
      </div>
      <div className={styles.mobileBenefitsTableContents}>
        <div className={classnames({ [styles.selected]: selectedTab === 0 })}>
          <div style={{ fontWeight: 500, fontSize: '12pt', marginTop: 20 }}>Hive Benefits</div>
          <div>
            <div>Free shipping on all orders</div>
            <div>On orders over $75</div>
          </div>
          <div>
            <div>Double credits on all purchases</div>
            <div>-</div>
          </div>
          <div>
            <div>Birthday discount</div>
            <div>10%</div>
          </div>
          <div>
            <div>Early access to sales + discounts</div>
            <div>Yes!</div>
          </div>
          <div style={{ borderBottom: 0 }}>
            <div>Early access to product releases</div>
            <div>-</div>
          </div>
        </div>
        <div className={classnames({ [styles.selected]: selectedTab === 1 })}>
          <div style={{ fontWeight: 500, fontSize: '12pt', marginTop: 20 }}>Honey Bee Benefits</div>
          <div>
            <div>Free shipping on all orders</div>
            <div>Yes!</div>
          </div>
          <div>
            <div>Double credits on all purchases</div>
            <div>LiftWear only</div>
          </div>
          <div>
            <div>Birthday discount</div>
            <div>15%</div>
          </div>
          <div>
            <div>Early access to sales + discounts</div>
            <div>Yes!</div>
          </div>
          <div style={{ borderBottom: 0 }}>
            <div>Early access to product releases</div>
            <div>Yes!</div>
          </div>
        </div>
        <div className={classnames({ [styles.selected]: selectedTab === 2 })}>
          <div style={{ fontWeight: 500, fontSize: '12pt', marginTop: 20 }}>Queen Bee Benefits</div>
          <div>
            <div>Free shipping on all orders</div>
            <div>Yes!</div>
          </div>
          <div>
            <div>Double credits on all purchases</div>
            <div>Yes!</div>
          </div>
          <div>
            <div>Birthday discount</div>
            <div>20%</div>
          </div>
          <div>
            <div>Early access to sales + discounts</div>
            <div>Yes!</div>
          </div>
          <div style={{ borderBottom: 0 }}>
            <div>Early access to product releases</div>
            <div>Yes!</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileBenefitsTable;
